import styled from 'styled-components';

export const Button = styled.button`
    border: none;
    border-radius: 5px;
    padding: 10px;
    margin: 0;
    min-width: 100px;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    color: #fff;
    background: #252161;
    display: flex;
    align-items: center;
    justify-content: center;
    :hover{
        opacity: 0.9;
    }
    :disabled{
        opacity: 0.8;
    }
`;

export const SecondaryButton = styled(Button)`
    background: #fafafa;
    color: #000;
    border: 1px solid #121180;
    :hover{
        background: #fff;
    }
`;